import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class IdentifiableAPI extends ComponentAPI {
    /**
     * Updates the current identifier
     * @param identifier - The identifier value
     */
    setIdentifier(identifier) {
        this.setState({ identifier });
    }
    /**
     * Returns the current identifier
     */
    getIdentifier() {
        return this.state.identifier;
    }
}
export { IdentifiableAPI, };
//# sourceMappingURL=identifiable-api.js.map